



































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import NullableField from "../NullableField.vue";
import Vehicle from "../../models/vehicle";

const vehicle = namespace("vehicle");

@Component({
  components: {
    NullableField,
  },
})
export default class VehiclesTable extends Vue {
  @Prop({ default: [] }) headers!: Record<string, any>[];

  @Prop({ default: false }) isLoading!: boolean;

  @Prop({ required: true }) options!: any;

  @Prop({ default: 0 }) totalVehicles!: number;

  @Prop({ default: [] }) vehicles!: Vehicle[];

  footerProps = { "items-per-page-options": [10, 25, 50, 100] };

  tableOptions: any = {
    groupBy: [],
    groupDesc: [],
    multiSort: true,
    mustSort: false,
    sortDesc: [],
    page: 1,
    itemsPerPage: 10,
    sortBy: [],
  };

  @Watch("options")
  onOptionsChanged(val: any, _oldVal: any) {
    Object.assign(this.tableOptions, val);
  }

  @Watch("tableOptions")
  onTableOptionsChanged(val: any, _oldVal: any) {
    if (val === this.options) {
      return;
    }
    this.$emit("update:options", this.tableOptions);
  }

  mounted() {
    Object.assign(this.tableOptions, this.options);
  }

  @vehicle.Action("fetchByVin")
  fetchByVin!: (vin: string) => Promise<any>;

  didClickRow(vehicle: Vehicle): void {
    if (!vehicle.vin) {
      return;
    }
    this.fetchByVin(vehicle.vin);
    this.$router.push(`/vehicles/${vehicle.vin}`);
  }
}
